<template>
  <div class="card">
    <div class="card-header text-center py-2">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <form @submit.prevent="guardar">
        <div class="form-group row mb-1">
          <label for="inputNombre" class="col-sm-2 col-form-label">Descripción:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.descripcion"
            class="form-control form-control-sm"
            :required="true"
            id="inputNombre"
            >
          </div>
          <label for="inputCodigo" class="col-sm-2 col-form-label">Código:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.codigo"
            class="form-control form-control-sm"
            id="inputCodigo"
            >
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="selectRestaurante" class="col-sm-2 col-form-label">Restaurante:</label>
          <div class="col-sm-4">
            <select id="selectRestaurante" class="form-control form-control-sm" v-model="form.carta_restaurante_id">
              <option v-for="i in catalogo.restaurante" :value="i.id" :key="i.id">{{ i.nombre }}</option>
            </select>
          </div>
          <div class="col-sm-6 text-right">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1 mt-3"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="submit" class="btn btn-sm btn-primary mt-3" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <span v-if="inicio">Buscando...</span>
      <div class="input-group input-group-sm mb-0" v-else>
        <input 
          type="text" 
          class="form-control" 
          v-model="listaTermino"
          placeholder="Buscar por descripcion" 
          aria-label="Buscar por descripcion" 
          aria-describedby="btnBuscarNombre"
        >
        <div class="input-group-append">
          <button 
            class="btn btn-outline-secondary px-3" 
            type="button" 
            @click="verForm = !verForm"
            id="btnBuscarNombre"
          >
            <font-awesome-icon icon="angle-up" v-if="verForm"/>
            <font-awesome-icon icon="angle-down" v-else/>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="!inicio">
      <table class="table table-sm">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Descripción</th>
            <th scope="col">Código</th>
            <th scope="col">Restaurante</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td><a href="#" @click.prevent="editar(idx)">{{ i.descripcion }}</a></td>
            <td>{{ i.codigo }}</td>
            <td>{{ i.nrestaurante }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import CartaCatalogo from '../mixins/CartaCatalogo.js';
import ManteAccion from '../mixins/ManteAccion.js';

export default {
  name: 'ManteCartaMesa',
  mixins: [CartaCatalogo,ManteAccion],
  data: () => ({
    titulo: 'Mesa'
  }),
  created () {
    this.nombre = 'mesa';
    this.listaFiltrar = 'descripcion';
    this.getCatalogo(['restaurante']);
  }
}
</script>